import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addRecipelistOfMealTimeApi, listOfDietTypesApi, listOfMealTimeApi, updateRecipelistOfMealTimeApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE, NUMBER_PATTERN } from "../../../../../config/constant";
import { FilterApiData } from "../../../../../services/FilterApiData";

export const MealTime = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [dietTypeOptionsList, setDietTypeOptionsList] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [mealTimeData, setmealTime] = useState()
    const [editMealTimeRecord, seEdittMealTimeRecord] = useState()
    const [arrayOfSelectedDropdownValue, setArrayOfSelectedDropdownValue] = useState([])
    const [loading, setLoading] = useState(false)

    // here create an array of object all tags related selected dropdown values 
    // =================================    
    const CreateArrayOfSelectedValue = (id, task) => {
        // console.log(id);
        // console.log(task);
        if (id == undefined) {
            setArrayOfSelectedDropdownValue([])
        }
        // console.log(arrayOfSelectedDropdownValue);
        if (id) {
            let object = dietTypeOptionsList.find((element) => element.id == id)
            if (task == "add") {
                // if selected option object is available inside array only push if not available
                let valueExist = arrayOfSelectedDropdownValue.find((element) => element.diet_type_id == object.id)
                // console.log(arrayOfSelectedDropdownValue);
                if (!valueExist) {
                    object.diet_type_id = object.id

                    arrayOfSelectedDropdownValue.push(object)
                }
                // console.log(arrayOfSelectedDropdownValue);
            }
            if (task == "remove") {
                const indexOfElement = arrayOfSelectedDropdownValue.findIndex((record) => record.diet_type_id == object.id);
                arrayOfSelectedDropdownValue.splice(indexOfElement, 1);
                // console.log(arrayOfSelectedDropdownValue);
            }
        }


    }

    // get the list of all available mealtime data 
    //==============================
    const getListOfMealTime = () => {
        setLoading(true)
        listOfMealTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get the list of all Diet types option list
    //==============================
    const getListOfDietTypes = () => {
        setLoading(true)

        listOfDietTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDietTypeOptionsList(FilterApiData(res.data.data));
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // call when user click on edit
    //==============================
    const editRecipeMealTime = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'recipe_meal_time': data.name })
        form.setFieldsValue({ 'diet_dropdown_count': data.diet_dropdown_count })
        seEdittMealTimeRecord(data);
        // console.log(data);
        // console.log("dietTypeOptionsList", dietTypeOptionsList);

        // create an array of selected dirt types ids and set it in form  
        if (data && data?.meal_time_diet_type.length > 0) {
            let temp;
            temp = data?.meal_time_diet_type?.filter((element) => element.diet_type_id).map(a => (a.diet_type_id))
            form.setFieldsValue({ "diet_types": temp })
        }
        setArrayOfSelectedDropdownValue(data?.meal_time_diet_type)
    }

    useEffect(() => {
        getListOfMealTime()
        getListOfDietTypes()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterMealTime(mealTimeData);
    }, [mealTimeData]);

    // filter recipe Meal Time
    //==============================
    const filterMealTime = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe Meal Time
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateRecipelistOfMealTimeApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Recipe MealTime Update successfully",
                    });
                    getListOfMealTime()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        {
            title: 'Meal Time',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Diet Dropdown Count',
            dataIndex: 'diet_dropdown_count',
            key: 'diet_dropdown_count',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRecipeMealTime(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Breakfast',
            status: true
        },
        {
            id: '2',
            name: 'Mid Morning',
            status: false
        },
        {
            id: '3',
            name: 'Lunch',
            status: true
        },
        {
            id: '4',
            name: 'Evening',
            status: true
        },
        {
            id: '',
            name: 'Dinner',
            status: true
        },
    ];

    const [form] = Form.useForm();

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.recipe_meal_time,
                "diet_dropdown_count": values.diet_dropdown_count,
                "meal_time_diet_type": arrayOfSelectedDropdownValue,
                "status": true
            }
            // console.log(data);
            addRecipelistOfMealTimeApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'recipe_meal_time': '' })
                        form.setFieldsValue({ 'diet_dropdown_count': '' })
                        form.setFieldsValue({ 'diet_types': [] })
                        notification.success({
                            message: "Meal Time added successfully",
                        });
                        getListOfMealTime()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.recipe_meal_time,
                "diet_dropdown_count": values.diet_dropdown_count,
                "meal_time_diet_type": arrayOfSelectedDropdownValue,
                "status": values.status
            }
            // console.log(data);
            updateRecipelistOfMealTimeApi(editMealTimeRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Meal Time Update successfully",
                        });
                        getListOfMealTime()
                        form.setFieldsValue({ 'recipe_meal_time': '' })
                        form.setFieldsValue({ 'diet_dropdown_count': '' })
                        form.setFieldsValue({ 'diet_types': [] })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="MealTime">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addMealTimeForm"
                        className="addMealTime"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addMealTimeForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="recipe_meal_time"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Meal Time!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Meal Time" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={4} className="ms-1">
                                <Form.Item
                                    name="diet_dropdown_count"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Dropdown Count!",
                                        },
                                        {
                                            pattern: NUMBER_PATTERN,
                                            message: NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Dropdown Count" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="diet_types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Diet Type!",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select Diet Types"
                                        allowClear
                                        showSearch
                                        // onChange={handleChange}
                                        filterOption={(inputValue, option) =>
                                            option.children.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        maxTagCount="responsive"
                                        mode="multiple"
                                        onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                        onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                    >
                                        {dietTypeOptionsList &&
                                            dietTypeOptionsList.length > 0 &&
                                            dietTypeOptionsList.map((option, index) =>
                                                <Option
                                                    key={option.id} value={option.id}>{option.name}</Option>
                                            )}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={3}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />} >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total Meal Times:  {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Meal Time"
                        onChange={(e) => { filterMealTime(e.target.value); setmealTime(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
